import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class GoogleAnalyticsEventsService {

	error: any;
	results: any;

	constructor(private http: HttpClient) {
		// this.eventCount();
	}

	public emitEvent(eventCategory: string,
                   eventAction: string,
                   eventLabel: string = null,
                   eventValue: number = null) {
	    
	    ga('send', 'event', {
	      eventCategory: eventCategory,
	      eventLabel: eventLabel,
	      eventAction: eventAction,
	      eventValue: eventValue
	    });
	}


	public eventCount() {
		return this.http.get("/analytics/getAnalytics.php?t="+ Math.random());
	}

}
